import type { AvailableReward, ResolutionData } from 'api/recoveryAi.types'

// Map a terminal ResolutionData (the dry-run reward the agent DID grant) to the
// AvailableReward the inline chat-offer card renders (AI-516). Prefer the
// matching approved-reward template so the card carries #565 enrichment
// (image_url/value_cents/points); fall back to a thin reward synthesized from
// the resolution when no template matches (id divergence, or a shell — the
// wizard — that omits approvedRewards). Escalations carry no reward, so the
// caller passes only ResolutionData here.
const offerFromResolution = (
  resolution: ResolutionData | null,
  approvedRewards?: AvailableReward[]
): AvailableReward | null => {
  if (!resolution) return null

  const match = approvedRewards?.find(r => r.id === resolution.reward_id)
  if (match) return match

  return {
    id: resolution.reward_id,
    label: resolution.reward_name,
    cost_cents: resolution.reward_cost_cents,
    type: resolution.reward_type,
    active: true,
  }
}

export default offerFromResolution
